import React from 'react'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import InputRowReadOnly from '../elements/InputRowReadOnly'

const options = {
    postUrl: '/api/postChangeIpSubnet',
    success: 'Your IP subnet change has been completed successfully.',
    dontScrollToNav: true,
    showHideIcon: true
}
const state = {}

class ChangeIpSubnetForm extends React.Component {
    componentDidMount () {
        this.props.setDynamicValues({
            serviceId: this.props.serviceId
        })
    }

    render () {
        return (
            <form onSubmit={this.props.handleSubmit} onKeyDown={this.props.handleKeyDown}>
                <InputRowReadOnly
                    label='Current IPv6 Subnet'
                    value={this.props.data.currentSubnet}
                />
                <InputRowReadOnly
                    label='Next available IPv6 Subnet'
                    value={this.props.data.nextAvailableSubnet}
                />

                {this.props.children}

                <div className='row mt-3'>
                    <div className='col-12 text-center text-md-right'>
                        <div className='d-inline-block my-md-2'>
                            <Button title='Change Subnet' action={this.props.handleSubmit} />
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}

export default FormHOC(ChangeIpSubnetForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/ChangeIpSubnetForm.js